import React, { MouseEvent, startTransition } from "react";
import YoutubeFacade from "./youtube.facade";

type IframeComponentProps = {
    title: string;
    src: string;
}

type IframeComponentState = {
    clicked: boolean;
    mounted: boolean;
}

export default class IframeComponent extends React.Component<IframeComponentProps, IframeComponentState> {
    
    state: IframeComponentState = {
        clicked: this.isYoutubeUrl ? false : true,
        mounted: false,
    }

    static getYoutubeVideoId(src: string = "") {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        const match = src.match(regExp);
        if (match && match[2].length == 11) { return match[2]; }
        return undefined;
    }

    static concatAutoplayParameter(src: string = "") {
        if (src.indexOf("?") === -1) return src + '?autoplay=1';
        return src + '&autoplay=1';
    }

    get isYoutubeUrl() {
        if (IframeComponent.getYoutubeVideoId(this.props.src)) return true;
        return false;
    }

    renderFacade() {
        if (this.isYoutubeUrl && !this.state.clicked) {
            const id = IframeComponent.getYoutubeVideoId(this.props.src) as string;
            return <YoutubeFacade id={id} />
        }
        return this.renderComponent();
    }

    renderComponent() {
        if (this.isYoutubeUrl && this.state.clicked) {
            const src = IframeComponent.concatAutoplayParameter(this.props.src);
            return <iframe allow='autoplay' title={this.props.title} className="w-full iframe-frame" src={src} />
        }
        if (this.state.mounted) return <iframe allow="" loading="lazy" title={this.props.title} className="w-full iframe-frame" src={this.props.src} />
        return null;
    }

    onClick = (ev: MouseEvent<HTMLDivElement>) => {
        if (!this.state.clicked) this.setState({clicked: true});
    }

    /** defer normal iframes until hydration: */
    componentDidMount(): void {
        startTransition(() => { this.setState({mounted: true}) })
    }

    render(): React.ReactNode {
        return <div onClick={this.onClick}>
            {this.renderFacade()}
        </div>
    }
}